import React from "react";
import "./WeCraft.css";
import { Container } from "react-bootstrap";
import { TypeAnimation } from "react-type-animation";
import "../../../../App.css";

const WeCraft = () => {
  return (
    <>
      <section className="weCraft-section">
        <Container>
          <div className="row align-items-center">
            <div className="col-12 col-md-6 col-xl-6 about-us-order-2">
              <div className="hero-title">
                <div className="hero-dec-text">
                  <h1 className="h1">
                    We Craft Digital Solutions that
                    <br />
                    <TypeAnimation
                      cursor={false}
                      sequence={["Empower Businesses!", 1000, "", 1000]}
                      wrapper="span"
                      repeat={Infinity}
                    />
                    <span>|</span>
                  </h1>
                  <div className="dec-text">
                    <p>
                      Since 2010, we have been revolutionizing the industry with
                      custom software development service solutions. With our
                      cutting-edge expertise and passion for excellence, we
                      deliver exceptional solutions tailored to meet your unique
                      needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-xl-6 about-us-order-1">
              <div className="counters-banner-wrapper">
                <div className="counter-items">
                  <div className="ach_right">
                    <div className="counter-item counter-item-first">
                      <span
                        className="count counter-value"
                        style={{ color: "var(--orange-color)" }}
                      >
                        400
                      </span>
                      <span
                        className="counter-value"
                        style={{ color: "var(--orange-color)" }}
                      >
                        +
                      </span>
                      <div className="counter-line"></div>
                      <div className="info-content">Happy Clients</div>
                    </div>
                  </div>
                  <div className="ach_right">
                    <div className="counter-item counter-item-second">
                      <span
                        className="count counter-value"
                        style={{ color: "var(--x-primary-color)" }}
                      >
                        850
                      </span>
                      <span
                        className="counter-value"
                        style={{ color: "var(--x-primary-color)" }}
                      >
                        +
                      </span>
                      <div className="counter-line"></div>
                      <div className="info-content">Projects Delivered</div>
                    </div>
                  </div>
                  <div className="ach_right">
                    <div className="counter-item counter-item-third">
                      <span
                        className="count counter-value"
                        style={{ color: "var(--purple-color)" }}
                      >
                        92
                      </span>
                      <span
                        className="counter-value"
                        style={{ color: "var(--purple-color)" }}
                      >
                        %
                      </span>
                      <div className="counter-line"></div>
                      <div className="info-content">Client Retention</div>
                    </div>
                  </div>
                </div>
                <div className="years-success-rotation">
                  <svg
                    width="275"
                    height="275"
                    viewBox="0 0 275 275"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <path
                        id="circlePath"
                        d=" M 138, 138 m -120, 0 a 120,120 0 0,1 240,0 a 120,120 0 0,1 -240,0 "
                      ></path>
                    </defs>
                    <g>
                      <use href="#circlePath" fill="none"></use>
                      <text fill="#000">
                        <textPath href="#circlePath">
                          14 years of success &nbsp; 14 years of success
                        </textPath>
                      </text>
                    </g>
                  </svg>
                  <div className="years-text">
                    <p>14</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default WeCraft;
